import { api } from './api';

export interface FileUploadResponse {
  message: string;
  data: {
    file: string;
  };
  error: boolean;
}

export const fileService = {
  async uploadFile(file: File): Promise<string> {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post<FileUploadResponse>('/file', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    
    return response.data.data.file;
  }
};

export default fileService;